'use strict';

exports.__esModule = true;
exports.safeInvariant = exports.invariant = exports.safeError = exports.error = exports.safeWarning = exports.warning = undefined;
var _inProduction = require('in-production');
var _inProduction2 = _interopRequireDefault(_inProduction);
var _tryConsoleError = require('./utils/try-console-error');
var _tryConsoleError2 = _interopRequireDefault(_tryConsoleError);
var _breakpoint = require('./utils/breakpoint');
var _breakpoint2 = _interopRequireDefault(_breakpoint);
var _constants = require('./constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var warning = exports.warning = function warning() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.DEFAULT_WARNING_MESSAGE;
  (0, _tryConsoleError2["default"])(message);
  (0, _breakpoint2["default"])(message);
};
var safeWarning = exports.safeWarning = function safeWarning(message) {
  if (_inProduction2["default"]) return;
  warning(message);
};
var error = exports.error = function error() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.DEFAULT_ERROR_MESSAGE;
  throw new Error(message);
};
var safeError = exports.safeError = function safeError(message) {
  if (_inProduction2["default"]) return;
  error(message);
};
var invariant = exports.invariant = function invariant(condition) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.DEFAULT_INVARIANT_MESSAGE;
  if (!condition) error(message);
};
var safeInvariant = exports.safeInvariant = function safeInvariant(condition, message) {
  if (_inProduction2["default"]) return;
  invariant(condition, message);
};